var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "goods_info" },
    [
      _c("el-image", {
        staticClass: "goods_pic",
        attrs: {
          src: _vm.row.goodsPic,
          "preview-src-list": [_vm.row.goodsPic],
          fit: "scale-down",
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "goods_detail" }, [
        _c("div", { staticClass: "goods_title" }, [
          _vm.platformIcon[_vm.row.platformCode]
            ? _c("img", {
                staticClass: "platform_icon",
                attrs: { src: _vm.platformIcon[_vm.row.platformCode], alt: "" },
              })
            : _vm._e(),
          _vm._v(" "),
          _c("span", [_vm._v(_vm._s(_vm.row.title))]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "goods_id" }, [
          _vm._v("\n      商品ID:" + _vm._s(_vm.row.goodsId) + "\n      "),
          _c("span", { staticClass: "copy_chip", on: { click: _vm.onCopy } }, [
            _vm._v("复制"),
          ]),
        ]),
        _vm._v(" "),
        _vm.row.payTime
          ? _c("div", { staticClass: "goods_id" }, [
              _vm._v("\n      付款时间：" + _vm._s(_vm.row.payTime) + "\n    "),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "goods_price" }, [
          _c("div", [
            _vm._v("券后价："),
            _c("span", { staticClass: "coupon_price" }, [
              _vm._v("￥" + _vm._s(_vm.row.couponPrice)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "ml20" }, [
            _vm._v("\n        原价："),
            _c("span", { staticClass: "origin_price" }, [
              _vm._v("￥" + _vm._s(_vm.row.originPrice)),
            ]),
          ]),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }